export const LOGIN = 'LOGIN';
export const BUTTON = 'BUTTON'; 